import React from "react";
import { DownOutlined } from "@ant-design/icons";
import { CheckboxSelectStyle } from "../types";

type SelectButtonProps = {
  title: string | React.ReactNode;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dataTestId: string;
  width: number;
  style: CheckboxSelectStyle;
  selectedItems: string[];
  disabled: boolean;
  className: string;
  height?: number;
};

const buttonStyle: Record<
  CheckboxSelectStyle,
  { border: string; backgroundColor: string }
> = {
  regular: {
    border: "1px solid #C4CDD0",
    backgroundColor: "white",
  },
  active: {
    border: "1px solid #0E98D0",
    backgroundColor: "#ECFAFF",
  },
};

export const SelectButton = ({
  title,
  setOpen,
  dataTestId,
  width = 200,
  style,
  selectedItems,
  disabled,
  height = 35,
  className,
}: SelectButtonProps) => {
  return (
    <button
      data-testid={`${dataTestId}-button`}
      className={`ant-select-selector text-left  border-solid border-[#C4CDD0] border rounded-[4px] px-[11px] items-center bg-white overflow-hidden text-[14px]   flex  justify-between text-nowrap text-ellipsis disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 w-full ${className}`}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        ...buttonStyle[style],
      }}
      name="Select"
      value={selectedItems}
      disabled={disabled}
      onClick={() => setOpen((open) => !open)}
    >
      {typeof title === "string" ? (
        <span className="text-ellipsis w-[95%] overflow-hidden">{title}</span>
      ) : (
        title
      )}
      <DownOutlined className="text-[12px]" />
    </button>
  );
};
